import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge должен знать собственные размеры текста, иначе склеит их с цветами.
const merge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['caption', 'small', 'body', 'lead', 'title', 'heading', 'figure'],
    },
    classGroups: {
      'border-w': ['border-thick'],
    },
  },
});

/** Склейка классов Tailwind с разрешением конфликтов. */
export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
